import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreGridContainer } from "@slhuicore/grid-container/index.js";
import { style } from "./assets/container.generated-style";

/**
 * Provides the ability to horizontally align and pad contained elements
 *
 * @CustomElement slh-container
 */
@customElement("slh-container")
export default class SlhContainer extends SlhCoreGridContainer(LitElement) {
  static styles = style;
}
